import { usePathname } from "next/navigation";
import { Text } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import { AccountLike } from "./types";
import AccountIcon from "./AccountIcon";
import styles from "./AccountItem.module.css";

interface Props {
  account: AccountLike;
  isCurrentAccount: boolean;
}

const AccountItem = ({ account, isCurrentAccount }: Props) => {
  const pathname = usePathname();
  const href = isCurrentAccount
    ? undefined
    : `/switch-account?account=${account.id}&next=${encodeURIComponent(
        String(pathname),
      )}`;
  const subtitle = account.email ?? "Team account";

  return (
    <a
      aria-label={`Switch to the account for ${account.name}`}
      className={[
        styles.linkCss,
        !isCurrentAccount && styles.interactiveCss,
      ].join(" ")}
      data-testid="account-item"
      href={href}
    >
      <div className={styles.containerCss}>
        <AccountIcon account={account} isCurrentAccount={isCurrentAccount} />
        <div className={styles.labelContainerCss}>
          <Text type="SmallPrint4">{account.name}</Text>
          <Text color="GrayWarm6" type="SmallPrint1">
            {subtitle}
          </Text>
        </div>
        {!isCurrentAccount && (
          <Icon color="GrayWarm6" name="arrowSmallRight" size={18} />
        )}
      </div>
    </a>
  );
};

export default AccountItem;
